import { render, staticRenderFns } from "./PendingFollowups.vue?vue&type=template&id=a3a5fdcc&scoped=true&"
import script from "./PendingFollowups.vue?vue&type=script&lang=js&"
export * from "./PendingFollowups.vue?vue&type=script&lang=js&"
import style0 from "./PendingFollowups.vue?vue&type=style&index=0&id=a3a5fdcc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3a5fdcc",
  null
  
)

export default component.exports